import { withStyles } from '@material-ui/core';

import { styles } from './DocumentsControl.styles';
import DocumentsControl from './DocumentsControl';

const DocumentsControlContainer = withStyles(styles)(DocumentsControl);

export default DocumentsControlContainer;
